<template>
  <v-card class="company-invoice-card">
    <div class="d-flex align-center">
      <p class="card-title">
        {{ $t('purchaseV2.basket.companyInvoice') }}
      </p>
      <v-switch
        color="primary"
        :input-value="isCompanyInvoice"
        @change="onToggleInvoice"
        class="pl-2" />
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'BasketCompanyInvoiceCard',
  props: {
    isCompanyInvoice: { type: Boolean, required: true },
  },
  methods: {
    onToggleInvoice(value) {
      this.$emit('update:is-company-invoice', Boolean(value))
    },
  },
}
</script>

<style scoped>
.company-invoice-card {
  margin-bottom: 1.625rem;
  padding: 0.5rem;

  --card-title-color: var(--v-primary-text-darken4);

  &.theme--dark {
    --card-title-color: var(--v-primary-text-base);
  }
}

.card-title {
  margin: 0 0 0 0.5rem;
  flex: 1 1 auto;
  min-width: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--card-title-color);
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
